import React, { useEffect } from 'react';
import { Link } from 'react-router-dom';
import PublicNav from '../components/dna/PublicNav';
import Footer from '../components/dna/Footer';

export default function LegalNoticePage() {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <div className="site-shell legal-page"><PublicNav /><div className="passio-terms-page">
      <header className="passio-terms-header">
        <div className="passio-terms-header-inner">
          <Link to="/" className="passio-terms-logo">
            <img src="/assets/Logo.png" alt="Pass'io" />
          </Link>
          <nav className="passio-terms-nav">
            <Link to="/" className="passio-terms-back">
              <i className="fas fa-arrow-left" /> Retour à l'accueil
            </Link>
          </nav>
        </div>
      </header>

      <div className="passio-terms-container">
        <aside className="passio-terms-sidebar">
          <div className="passio-terms-sidebar-inner">
            <h3 className="passio-terms-sidebar-title">Sommaire</h3>
            <nav className="passio-terms-toc">
              {[
                { id: 'editeur', title: 'Éditeur' },
                { id: 'hebergement', title: 'Hébergement' },
                { id: 'activite', title: 'Activité' },
                { id: 'propriete', title: 'Propriété intellectuelle' },
                { id: 'responsabilite', title: 'Responsabilité' },
                { id: 'cnil', title: 'Données personnelles' },
              ].map((s) => (
                <button
                  key={s.id}
                  onClick={() => {
                    const el = document.getElementById(s.id);
                    if (el) {
                      const top = el.getBoundingClientRect().top + window.pageYOffset;
                      window.scrollTo({ top: top - 80, behavior: 'smooth' });
                    }
                  }}
                  className="passio-terms-toc-link"
                >
                  {s.title}
                </button>
              ))}
            </nav>
          </div>
        </aside>

        <main className="passio-terms-content">
          <div className="passio-terms-hero">
            <span className="passio-terms-badge">Légal</span>
            <h1 className="passio-terms-title">Mentions Légales</h1>
            <p className="passio-terms-meta">
              Conformément à la réglementation en vigueur à Madagascar
            </p>
          </div>

          <section id="editeur" className="passio-terms-section">
            <h2>Éditeur de la plateforme</h2>
            <p>
              <strong>Pass'io</strong> est une plateforme de distribution musicale numérique éditée par :
            </p>
            <ul>
              <li><strong>Siège social :</strong> Antananarivo, Madagascar</li>
              <li><strong>Email :</strong> <a href="mailto:contact@passio.mg">contact@passio.mg</a></li>
              <li><strong>Contact Telegram :</strong> @PassioArtistBot</li>
            </ul>
          </section>

          <section id="hebergement" className="passio-terms-section">
            <h2>Hébergement</h2>
            <p>La plateforme Pass'io est hébergée sur les infrastructures suivantes :</p>
            <ul>
              <li>
                <strong>Serveur principal :</strong> Render (États-Unis / Allemagne)<br />
                <em>Render, 525 Brannan St Ste 300, San Francisco, CA 94107</em>
              </li>
              <li>
                <strong>Stockage de fichiers :</strong> Backblaze B2 — Cloud Storage<br />
                <em>Données hébergées en région Europe Centrale</em>
              </li>
              <li>
                <strong>Base de données :</strong> Aiven (PostgreSQL)<br />
                <em>Infrastructure cloud européenne</em>
              </li>
              <li>
                <strong>Application mobile :</strong> Expo (OTA updates)<br />
                <em>Mises à jour diffusées via les serveurs Expo</em>
              </li>
            </ul>
            <div className="passio-terms-notice">
              <i className="fas fa-server" />
              <p>
                Les données sont traitées et stockées conformément aux meilleures pratiques de sécurité
                internationales. Pass'io s'engage à choisir des hébergeurs respectant des standards
                élevés de protection des données.
              </p>
            </div>
          </section>

          <section id="activite" className="passio-terms-section">
            <h2>Activité</h2>
            <p>
              Pass'io est une plateforme permettant aux artistes malgaches de :
            </p>
            <ul>
              <li>Publier et distribuer leurs œuvres musicales sous format numérique</li>
              <li>Vendre leurs albums et singles via Mobile Money (MVola, Orange Money)</li>
              <li>Gérer leurs ventes et statistiques via un tableau de bord dédié</li>
              <li>Interagir avec leurs fans via un bot Telegram</li>
            </ul>
            <p>
              La plateforme propose deux formules d'abonnement : <strong>Free</strong> (gratuit) et{' '}
              <strong>Premium</strong> (2 000 Ar/mois), offrant des fonctionnalités et des commissions différenciées.
            </p>
          </section>

          <section id="propriete" className="passio-terms-section">
            <h2>Propriété intellectuelle</h2>
            <p>
              <strong>Marque :</strong> Le nom "Pass'io", le logo, et l'ensemble des éléments
              graphiques de la plateforme sont la propriété exclusive de l'éditeur.
              Toute reproduction ou utilisation sans autorisation est interdite.
            </p>
            <p>
              <strong>Code source :</strong> Le code source de la plateforme est la propriété
              exclusive de l'éditeur. Toute copie, modification, ou redistribution est interdite
              sans accord écrit préalable.
            </p>
            <p>
              <strong>Œuvres des artistes :</strong> Les œuvres musicales publiées sur la plateforme
              restent la propriété exclusive de leurs auteurs respectifs, conformément aux CGU.
            </p>
          </section>

          <section id="responsabilite" className="passio-terms-section">
            <h2>Responsabilité</h2>
            <p>
              L'éditeur de la plateforme s'efforce d'assurer au mieux de ses possibilités
              l'exactitude et la mise à jour des informations diffusées, dont elle se réserve
              le droit de corriger le contenu à tout moment et sans préavis.
            </p>
            <p>
              L'éditeur ne saurait être tenu responsable :
            </p>
            <ul>
              <li>Des interruptions temporaires du service pour maintenance ou mise à jour</li>
              <li>Des dommages indirects liés à l'utilisation de la plateforme</li>
              <li>Du contenu publié par les artistes (dont ils sont seuls responsables)</li>
              <li>Des dysfonctionnements des services tiers (MVola, Orange Money, Telegram)</li>
            </ul>
          </section>

          <section id="cnil" className="passio-terms-section">
            <h2>Données personnelles</h2>
            <p>
              Conformément à la réglementation malgache sur la protection des données personnelles,
              vous disposez d'un droit d'accès, de rectification et de suppression des données
              vous concernant.
            </p>
            <p>
              Pour exercer ces droits, consultez notre{' '}
              <Link to="/privacy">Politique de Confidentialité</Link> ou contactez-nous
              à <a href="mailto:contact@passio.mg">contact@passio.mg</a>.
            </p>
            <p>
              <Link to="/terms" className="btn btn-outline-danger btn-sm fw-semibold rounded-pill px-3 me-2">
                <i className="fas fa-file-contract me-1" /> Lire les CGU
              </Link>
              <Link to="/privacy" className="btn btn-outline-danger btn-sm fw-semibold rounded-pill px-3">
                <i className="fas fa-shield-halved me-1" /> Politique de confidentialité
              </Link>
            </p>
          </section>

          <footer className="passio-terms-footer">
            <p>
              Pass'io — Mentions Légales — Mise à jour Juillet 2026
            </p>
            <p>
              Antananarivo, Madagascar —{' '}
              <a href="mailto:contact@passio.mg">contact@passio.mg</a>
            </p>
          </footer>
        </main>
      </div>
      </div>
      <Footer />
    </div>
  );
}
